// @flow
import * as React from 'react';
import { renameKeys } from 'app/common/lib/object';
import ParamsContext from './ParamsContext';


/**
 * Контекст для параметров роутера
 */

type Props = {
  children: any,
  match: {
    params: Object,
    path: string,
  },
  location: {
    pathname: string,
  },
  history: {
    push: Function,
    replace: Function,
  },
}

const WithRouterParamsProvider = ({
  children,
  match: { params, path },
  location: { pathname },
  history: { push, replace },
}: Props) => (
  <ParamsContext.Provider
    value={{
      // $FlowFixMe
      params: renameKeys({ 0: 'splat' })(params),
      pathname,
      push,
      replace,
      pathMask: path,
    }}
  >
    {children}
  </ParamsContext.Provider>
);

export default WithRouterParamsProvider;
